import { getAuth } from "@firebase/auth";
import { useEffect, useState } from "react";
import DeleteHostelRoom from "../../../../Controllers/Admin/Hostel/DeleteHostelRoom";
import GetAllHostelRooms from "../../../../Controllers/Admin/Hostel/GetAllHostelRooms";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function RoomsListingViewModel() {
  const [RoomID, setRoomID] = useState("");
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(true);
  const [Refresh, setRefresh] = useState(true);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [AuthUser, setAuthUser] = useState();
  const [RoomsArray, setRoomsArray] = useState([]);

  const HandleRefresh = () => {
    setIsLoading(true);
    setRefresh(!Refresh);
  };

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const RoomsData = await GetAllHostelRooms(AuthUser?.uid, SchoolID);
      setRoomsArray(RoomsData);
      setIsLoading(false);
    }
    fetchData();
  }, [AuthUser?.uid, SchoolID, Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setRoomID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteHostelRoom(RoomID);
      ToastSuccessMessages("hostel/delete-successful");
      HandleRefresh();
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    RoomsArray,
    IsLoading,
  };
}
